export const calculateTime = (time) =>{
    const hrs = Math.floor(time/60);
    const min = Math.floor(time%60);
    const formatWithTwoDigits = new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      });
    return `${formatWithTwoDigits.format(hrs)}:${formatWithTwoDigits.format(min)}`; 
}